import request from '@/utils/request'

const http = request()

export const listLxFormData = params => http.post('/lx/page', params)

export const getLxFormData = id => http.post(`/lx/${id}`)

export const buildProject = params => http.post('/lx/build', params)
